import { SlideMedia } from '../../../types/interfaces';

import { Image } from './Image';
import { Media } from './Media';
import { Video } from './Video';

export class MediaFactory {
  static get(media: SlideMedia): Media {
    if (media.image) {
      return Image.from(media.image);
    }
    return Video.from(media.video!);
  }
}
